/* eslint-disable consistent-return */

// eslint-disable-next-line import/no-extraneous-dependencies
import _ from 'lodash';

import { getAvailableQuantity, isApplicableItem, mergeSatisfiers } from './common';
import { orderProductsForDiscountPrecedence } from '../utilities';

const isEligibleWeight = (reward, item) =>
  _.isNil(reward.weight) || reward.weight === 'Any Weight' || item.option === reward.weight;

const issueStandardRewards = (bogoCalcsData, bogoSpecial, conditionsManager, items) => {
  const { bogoRewardLogicOperator, bogoRewards, specialId } = bogoSpecial;
  let rewardsSatisfiers = {};
  const sortedItems = orderProductsForDiscountPrecedence(items, conditionsManager.specialsSettings, 'rewards');
  let finishedSatisfyingRewards = false;
  let remainingSatisfiersCount = _.reduce(bogoRewards, (prev, curr) => (prev += curr?.quantity ?? 0), 0);

  _.forEach(sortedItems, (item) => {
    _.forEach(bogoRewards || [], (reward) => {
      let rewardAssigned = false;
      let rewardQuantityRemaining = reward.quantity ?? 0;
      if (isApplicableItem(reward, item, bogoSpecial, `reward`) && isEligibleWeight(reward, item)) {
        const itemsUsedForConditions = conditionsManager.satisfiers?.[item.key]?.quantity ?? 0;
        // TODO: optimize how reshuffling occurs
        const attemptConditionShuffle =
          itemsUsedForConditions > 0 &&
          // Don't reshuffle if defeated rewards would make it impossible
          (bogoCalcsData.defeatedRewardsSatisfiers?.[item.key]?.quantity || 0) < item.quantity;

        if (attemptConditionShuffle) {
          conditionsManager.evaluate({ itemToConsiderLast: item, pendingRewardsSatisfiers: rewardsSatisfiers });
        }

        const availableQuantity = getAvailableQuantity({
          item,
          bogoCalcsData,
          pendingConditionsSatisfiers: conditionsManager.satisfiers,
          pendingRewardsSatisfiers: rewardsSatisfiers,
          excludeDefeatedRewardsSatisfiers: true,
        });

        const previouslySatisfied = _.flatMap(_.values(rewardsSatisfiers), 'rewards');
        const isRewardAlreadySatisfied = !!_.find(previouslySatisfied, reward._id)?.[reward._id].satisfied;
        if (availableQuantity > 0 && !isRewardAlreadySatisfied) {
          const amountAwarded = Math.min(availableQuantity, rewardQuantityRemaining);
          rewardQuantityRemaining -= amountAwarded;
          rewardsSatisfiers = mergeSatisfiers(rewardsSatisfiers, {
            [item.key]: {
              item,
              quantity: amountAwarded,
              rewards: {
                [reward._id]: {
                  quantity: amountAwarded,
                  reward: { ...reward },
                  specialId,
                  satisfied: rewardQuantityRemaining < 1,
                  discountStacking: bogoSpecial.discountStacking,
                  discountPrecedence: bogoSpecial.discountPrecedence,
                  stackingBehavior: bogoSpecial.stackingBehavior,
                },
              },
            },
          });
          rewardAssigned = true;
        } else if (attemptConditionShuffle) {
          conditionsManager.revert();
        }
      }
      if (rewardQuantityRemaining < 1 || (rewardAssigned && bogoRewardLogicOperator === 'or')) {
        remainingSatisfiersCount -= 1;
        if (remainingSatisfiersCount === 0 || (rewardAssigned && bogoRewardLogicOperator === 'or')) {
          finishedSatisfyingRewards = true;
        }
        return false; // breaks early
      }
    });

    if (finishedSatisfyingRewards) {
      return false;
    }
  });
  return rewardsSatisfiers;
};

export default issueStandardRewards;
